<template>
  <section class="bg-white">
    <div class="section">
      <!-- Header -->
      <div class="text-center max-w-xl mx-auto mb-8 sm:mb-12">
        <p class="text-brand font-semibold text-sm uppercase tracking-widest mb-1">Simple & Easy</p>
        <h2 class="section-title">How It Works</h2>
        <p class="section-subtitle">
          From your door to ours — order in 3 easy steps
        </p>
      </div>

      <!-- Steps -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
        <!-- Connector line (desktop) -->
        <div class="hidden md:block absolute top-12 left-1/3 right-1/3 h-0.5 bg-brand-200 -z-0" />

        <div
          v-for="(step, index) in steps"
          :key="step.title"
          class="flex flex-col items-center text-center relative"
        >
          <!-- Icon circle -->
          <div class="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-brand-100 flex items-center justify-center mb-5 relative z-10 ring-4 ring-white">
            <span class="text-3xl sm:text-4xl">{{ step.emoji }}</span>
            <span class="absolute -top-2 -right-2 w-6 h-6 sm:w-7 sm:h-7 bg-brand text-white rounded-full text-xs font-bold flex items-center justify-center font-display">
              {{ index + 1 }}
            </span>
          </div>

          <h3 class="font-display font-bold text-accent text-lg mb-2">{{ step.title }}</h3>
          <p class="text-accent/60 text-sm leading-relaxed max-w-xs">{{ step.description }}</p>
        </div>
      </div>

      <!-- CTA -->
      <div class="text-center mt-12">
        <router-link to="/menu" class="btn-primary text-base px-10 py-3">
          Start Your Order
          <ArrowRightIcon class="w-5 h-5" />
        </router-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'

export default defineComponent({
  name: 'HowItWorks',
  components: { ArrowRightIcon },
  setup () {
    const steps = [
      {
        emoji: '📋',
        title: 'Browse Today\'s Menu',
        description: 'Check out what\'s freshly cooked today. Our menu changes daily so there\'s always something new.'
      },
      {
        emoji: '🛒',
        title: 'Place Your Order',
        description: 'Select your dishes, add to cart, and confirm your order. It only takes a minute.'
      },
      {
        emoji: '🛵',
        title: 'We Deliver to You',
        description: 'Sit back and relax. Your hot, home-cooked meal will arrive at your door within 30 minutes.'
      }
    ]
    return { steps }
  }
})
</script>
